export default function createPaintBrush(fabric: any) {
    fabric.PaintBrush = fabric.util.createClass(fabric.PencilBrush, {
        _lockX: false,
        _lockY: false,
        _lockDiagonalX: false,
        _lockDiagonalY: false,

        onMouseMove: function (pointer, shiftKey: boolean, ctrlKey: boolean) {
            if (shiftKey === undefined || ctrlKey === undefined) {
                return;
            }

            let x = pointer.x;
            let y = pointer.y;

            if (shiftKey) {
                if (this._points.length > 1) {
                    let lastpos = this._points[this._points.length - 1];

                    let angle =
                        (Math.atan2(pointer.y - lastpos.y, pointer.x - lastpos.x) * 180) / Math.PI;
                    angle = Math.abs(angle);
                    if (!this._lockY && (this._lockX || (angle < 135 && angle > 45))) {
                        x = lastpos.x;
                        this._lockX = true;
                    } else {
                        y = lastpos.y;
                        this._lockY = true;
                    }
                }
            } else if (ctrlKey) {
                if (this._points.length > 1) {
                    let lastpos = this._points[this._points.length - 1];

                    let angle =
                        (Math.atan2(pointer.y - lastpos.y, pointer.x - lastpos.x) * 180) / Math.PI;
                    if (
                        !this._lockDiagonalY &&
                        (this._lockDiagonalX ||
                            (angle >= -90 && angle <= 0) ||
                            (angle >= 90 && angle <= 180))
                    ) {
                        let pos = this.linepointNearestPoint(
                            lastpos,
                            { x: lastpos.x + 1, y: lastpos.y - 1 },
                            x,
                            y
                        );
                        x = pos.x;
                        y = pos.y;
                        this._lockDiagonalX = true;
                    } else if (
                        !this._lockDiagonalX &&
                        (this._lockDiagonalY ||
                            (angle > 0 && angle < 90) ||
                            (Math.abs(angle) > 90 && Math.abs(angle) < 180))
                    ) {
                        let pos = this.linepointNearestPoint(
                            lastpos,
                            { x: lastpos.x + 1, y: lastpos.y + 1 },
                            x,
                            y
                        );
                        x = pos.x;
                        y = pos.y;
                        this._lockDiagonalY = true;
                    }
                }
            } else {
                this._lockX = false;
                this._lockY = false;
                this._lockDiagonalX = false;
                this._lockDiagonalY = false;
            }

            let pointerPoint = new fabric.Point(x, y);
            this.callSuper('onMouseMove', pointerPoint);
        },

        linepointNearestPoint(pointA, pointB, pointX, pointY) {
            let lerp = function (a, b, x) {
                return a + x * (b - a);
            };
            let dx = pointB.x - pointA.x;
            let dy = pointB.y - pointA.y;
            let t = ((pointX - pointA.x) * dx + (pointY - pointA.y) * dy) / (dx * dx + dy * dy);
            let lineX = lerp(pointA.x, pointB.x, t);
            let lineY = lerp(pointA.y, pointB.y, t);
            return { x: lineX, y: lineY };
        }
    });
}
